export const config = {
    url_without_sso: [
         'gallery/creatGallery',
         'gallery/getGalleryDetails',
        'images/bySupplyId',
    ]
};
